export default {
  activeTabModel: null,
  default: {
    comments: {
      tab: 0,
      roleMap: {
        kyc: 2
      }
    }
  },
  list: []
}
